import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import PropTypes from 'prop-types';
import emojiFlags from 'emoji-flags';
import { get } from 'lodash';
/**
 * Use the `Flag` component to display a country's flag using the operating system's emojis.
 *
 * @return { object } - React component.
 */

var Flag = function Flag(_ref) {
  var code = _ref.code,
      order = _ref.order,
      className = _ref.className,
      size = _ref.size,
      hideFromScreenReader = _ref.hideFromScreenReader;
  var classes = classnames('woocommerce-flag', className);

  var _code = code || 'unknown';

  if (order && order.shipping && order.shipping.country) {
    _code = order.shipping.country;
  } else if (order && order.billing && order.billing.country) {
    _code = order.billing.country;
  }

  var inlineStyles = {
    fontSize: size
  };
  var emoji = get(emojiFlags.countryCode(_code), 'emoji');
  return createElement("div", {
    className: classes,
    style: inlineStyles,
    "aria-hidden": hideFromScreenReader
  }, emoji && createElement("span", null, emoji), !emoji && createElement("span", {
    className: "woocommerce-flag__fallback"
  }, "Invalid country flag"));
};

Flag.propTypes = {
  /**
   * Two letter, three letter or three digit country code.
   */
  code: PropTypes.string,

  /**
   * An order can be passed instead of `code` and the code will automatically be pulled from the billing or shipping data.
   */
  order: PropTypes.object,

  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * Supply a font size to be applied to the emoji flag.
   */
  size: PropTypes.number
};
export default Flag;
//# sourceMappingURL=index.js.map